import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { Redirect, Link } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { inHomeVerifyErrors } from "../../constants/textConstants"
import SchedulingQuestions from './SchedulingQuestions';
import Spinner from '../common/spinner';
import StickyProgressBar from '../common/StickyProgressBar';
import InHomeConfirmationModal from './InHomeConfirmationModal';
import InHomeCard from './InHomeCard';
import { Grid, Typography, Button, Card, Icon, Modal } from "../ecosystem/";
import * as msgs from "../../constants/textConstants";

const InHomeConfirmDetails = ({ history, apptTime, bookAppointment, bookApptPending, bookApptResult,
    screenBreakPoint, selectedDateTime, serviceLocation, cities, selectedUsers, selectedVaccines }) => {

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeConfirmDetails.Displayed`, new Date(), Tools.getURLPath());

    }, []);

    useEffect(() => {

        if (bookApptResult?.success) {
            history.push({ pathname: "/inhomeschedule/s8", state: { isBookingSuccess: true } })
        }
        else if (bookApptResult && bookApptResult?.errorMsg === inHomeVerifyErrors.TimeAlreadyBooked) {
            setShowModal(true);
        }
        else if (bookApptResult && bookApptResult?.errorMsg) {
            history.push({ pathname: "/inhomeschedule/s8", state: { isBookingSuccess: false } })
        }
    }, [bookApptResult])

    const [showModal, setShowModal] = useState(false);

    const onClickPrevious = () => {
        logUI(`MBHWeb.UI.InHomeConfirmDetails.Previous.Clicked`, new Date(), Tools.getURLPath());
        history.push({ pathname: "/inhomeschedule/s6", state: { isPreviousClicked: true } })
    }

    const onClickBook = () => {
        logUI(`MBHWeb.UI.InHomeConfirmDetails.Book.Clicked`, new Date(), Tools.getURLPath());
        bookAppointment();
    }

    const closeModal = () => {
        setShowModal(false);
        history.push("/inhomeschedule/s6")
    }

    const cancelBooking = () => {
        setShowModal(false);
        history.push("/")
    }

    const isMobileSize = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE || screenBreakPoint === msgs.MD_TABLET) ? true : false;

    const displayApptDateTime = Tools.getCentralDateWithFormat(selectedDateTime, 'dddd MMMM Do YYYY, h:mm A');
    const displayApptDate = Tools.getCentralDateWithFormat(selectedDateTime, 'dddd, MMMM D');
    const displayApptTime = Tools.getCentralDateWithFormat(selectedDateTime, 'h:mm A');

    const formatCity = (cityName) => {
        if (cityName && cities) {
            let formattedCity = cities.find(c => c.value === cityName.toLowerCase())
            if (formattedCity) return formattedCity.label;
        }
        return cityName;
    }
    const getSelectedVaccines = () => {
        const allSelectedVaccines = {};

        selectedVaccines.forEach(item => {
            item.vaccines_groups.forEach(group => {
                group.vaccines.forEach(vax => {
                    if (vax.isChecked) {
                        let user = selectedUsers.find(user => user.mrn === item.mrn)
                        if (allSelectedVaccines[vax.display_name] === undefined) {
                            allSelectedVaccines[vax.display_name] = { count: 1, users: [user.firstName] };
                        }
                        else {
                            allSelectedVaccines[vax.display_name].count = allSelectedVaccines[vax.display_name].count + 1;
                            allSelectedVaccines[vax.display_name].users.push(user.firstName);
                        }
                    }
                })
            })
        });
        return allSelectedVaccines;
    }

    const displaySelectedVaccines = () => {
        const arr = getSelectedVaccines();
        console.log("arrr")
        return Object.keys(arr).map((key) => (
            <div key={`vaccines-${key}`}>
                {arr[key].count}x {key} ({arr[key].users.join(", ")})
            </div>
        ))
    }
    const displayRecepients = () => {
        return selectedUsers && selectedUsers.map((u) => {
            return <div key={u.mrn}>
                {u.patientName} ({u.dob})
            </div>
        })

    }
    const displayLocationAndContact = () => {
        return <>
            <div>
                {serviceLocation?.address1}
            </div>
            <div>
                {serviceLocation?.address2}
            </div>
            <div>
                {formatCity(serviceLocation?.city)}, {serviceLocation?.state}, {serviceLocation?.zipCode}
            </div>
            <div>
                {serviceLocation?.email}
            </div>
            <div>
                {serviceLocation?.mobilePhone}
            </div>
        </>
    }

    const displayDateAndTime = () => {
        return <>
            <div>{displayApptDate}</div>
            <div>{displayApptTime}</div>
        </>
    }

    return (
        <>{!apptTime ? <Redirect to='/inhomeschedule/s8' /> :
            <>
                <StickyProgressBar className="inhome" />
                <Grid className="body-content body-content--no-top-offset body-content--no-footer inhome inhome-scheduling inhome-scheduling-container inhome-confirm-page">
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <div className="inhome-confirm-page__heading">
                                <Typography
                                    type={`${isMobileSize ? 'heading-05' : 'heading-06'}`}
                                >
                                    Almost done! How does everything look?
                                </Typography>
                                <div className="detail-sub-content">
                                    <Typography
                                        type="body-02"
                                    >
                                        Review your appointment details and make sure everything is correct before confirming your appointment.
                                    </Typography>
                                </div>
                            </div>
                            {bookApptPending && <Spinner />}
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <InHomeCard
                                        cardHeader="Location and Contact"
                                        editClick="/inhomeschedules"
                                        cardSubContent={displayLocationAndContact()}
                                    />
                                    <InHomeCard
                                        cardHeader="Eligibility/Screening"
                                        editClick="/inhomeschedule/s5"
                                        cardSubContent="Complete"
                                    />
                                    <InHomeCard
                                        cardHeader="Date and Time"
                                        editClick="/inhomeschedule/s6"
                                        cardSubContent={displayDateAndTime()}
                                    />

                                </div>
                                <div className="col-12 col-lg-6">
                                    <InHomeCard
                                        cardHeader="Recipients"
                                        editClick="/inhomeschedule/s3"
                                        cardSubContent={displayRecepients()}
                                    />
                                    <InHomeCard
                                        cardHeader="Vaccines"
                                        editClick="/inhomeschedule/s4"
                                        cardSubContent={displaySelectedVaccines()}
                                    />
                                </div>
                            </div>

                            <InHomeConfirmationModal />

                            <SchedulingQuestions />

                            <Modal
                                isOpen={showModal}
                                //onCloseClick={() => setShowModal(false)}
                                //className="inhome-modal"
                                modalHeader="The time you selected is no longer available."
                                modalBody="Please select a new time to continue booking."
                                modalFooterButtons={[
                                    { label: "Select new time", onClick: closeModal },
                                    { label: "Cancel booking", onClick: cancelBooking },
                                ]}
                            />
                            <div className="inhome-confirm-button">
                                <Button
                                    onClick={onClickBook}
                                >
                                    Confirm appointment
                                </Button>
                            </div>
                        </div>
                    </div>
                </Grid>
            </>
        }
        </>
    );
}
const mapStateToProps = state => {

    return {
        apptTime: state.inHome.selectedDateTime,
        bookApptPending: state.inHome.bookApptPending,
        bookApptResult: state.inHome.bookApptResult,
        screenBreakPoint: state.common.screenBreakPoint,
        selectedDateTime: state.inHome.selectedDateTime,
        serviceLocation: state.inHome.serviceLocationContactInfo,
        cities: state.inHome.prefilledCities,
        selectedUsers: state.inHome.selectedUsers || [],
        selectedVaccines: state.inHome.selectedVaccines || [],
    }
}

const mapDispatchToProps = dispatch => {
    return {
        bookAppointment: () => {
            dispatch({ type: types.BOOK_INHOME_APPT })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeConfirmDetails);